import Link from "next/link";
import EventiveTicketing from "../components/EventiveTicketing";
import Layout from "../components/Layout";
import PageHeader from "../components/PageHeader";
import {
  PricingSection,
  PricingSectionPriceDetail,
} from "../components/PricingSection";
import VirtualPricing from "../components/VirtualPricing";
import VirtualSinglePricing from "../components/VirtualSinglePricing";

export default function Pricing() {
  return (
    <Layout title="Pricing">
      <div>
        <PageHeader
          label="Pricing"
          headline="Simple, no-contract pricing for all our products"
          subhead={
            <span>
              No commitment. No hidden fees. Mix and match our products to build
              the independent film experience of your dreams. Eventive is
              available everywhere in the world, with native payments in over
              135 currencies as well as country-specific pricing &ndash;{" "}
              <button
                className="font-medium text-gray-900 focus:outline-none"
                onClick={() => {
                  Intercom(
                    "showNewMessage",
                    "I'm interested in learning more about country-specific pricing for Eventive! My name, organization, and country are: "
                  );
                }}
              >
                get in touch
              </button>
              .
            </span>
          }
        />
        <div className="relative mt-8 pb-12 sm:mt-12 sm:pb-16 lg:mt-16 lg:pb-24 bg-gray-50">
          <div className="absolute top-0 left-0 right-0 h-20 bg-white" />

          <PricingSection
            title="Eventive Platform"
            description="Full access to the Eventive event management platform (does not include Eventive Virtual)."
            includedItems={[
              "Online schedule of events and film guide",
              "Free audience registration for free events",
              "In-person box office and unified inventory management",
              "Thousands of integrations including Mailchimp and Salesforce",
            ]}
            priceDetail={
              <PricingSectionPriceDetail
                price="FREE"
                description="No contract. No setup fee. No annual fee. The full power of the Eventive Platform."
                buttonLabel="Get started free"
                buttonHref="/start"
              />
            }
          />

          <EventiveTicketing />

          <VirtualPricing
            title="Eventive Virtual Unlimited"
            description={
              <>
                One platform to make all your films and live events easily
                accessible for secure, ticketed viewing by audiences anywhere.
                Protected by{" "}
                <Link href="/antipiracy">
                  <a className="font-medium text-gray-700 hover:underline">
                    Eventive Advanced Antipiracy
                  </a>
                </Link>
                .
              </>
            }
          />

          <VirtualSinglePricing />

          <PricingSection
            title="Eventive for Distributors"
            description="Manage your entire virtual theatrical and VOD distribution channel using the only virtual screening platform designed for independent film."
            includedItems={[
              "MPAA-certified content protection and watermarking",
              "Unlimited screenings all from a single film upload",
              "Automated reporting and exhibitor revenue sharing",
              "White-label screening experience and custom apps",
            ]}
            priceDetail={
              <PricingSectionPriceDetail
                priceOther="Custom volume-based pricing options available"
                buttonLabel="Contact us"
                buttonHref="/start?goal=learn_more&type=distributor"
              />
            }
          />

          <PricingSection
            title="Eventive Balloting"
            description="A complete solution for audience awards and polling, both on-site and online. Generate, record, and tabulate using mobile, printed, and virtual ballots."
            priceDetail={
              <PricingSectionPriceDetail
                price="FREE"
                buttonLabel="Get started free"
                buttonHref="/start"
              />
            }
          />

          <PricingSection
            title="Eventive Premium Support"
            description="Trust our experts to go above and beyond to take care of every step of your event."
            includedItems={[
              "Dedicated account manager",
              "Guaranteed response time agreement",
              "Video and phone support",
              "Optional: Full concierge setup",
              "Optional: On-site box office management",
              "Optional: Event staffing",
            ]}
            priceDetail={
              <PricingSectionPriceDetail
                title="Monthly starting at"
                price="$1,800"
                priceNote="USD"
                description=""
                buttonLabel="Design your support plan"
                buttonHref="/start?goal=learn_more&message=I'd like to learn more about Eventive's premium support offerings!"
              />
            }
          />
        </div>
      </div>
    </Layout>
  );
}
